import React, { useState,  useEffect } from 'react';
import Bayan from './Bayan';
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@radix-ui/react-dialog";
import { FaTwitter } from 'react-icons/fa';
import { Slot } from "@radix-ui/react-slot";
import saf from './saf.svg';
import wheel from './wheel.svg';
import fridge from './fridge.svg';

const nationalitiesWithEmojis = [
  { text: "سعودي", emoji: <img src={saf} className='w-8 ml-2' /> },
  { text: "برتقالي", emoji: '🍊' },
  { text: "شمّري", emoji: '🚩' }, 
  { text: "مجهول", emoji: '❓' },
  { text: "ذبابي", emoji: '🪰' },
  { text: "اتحادي", emoji: '🟨⬛' }, 
];

const crimesWithEmojis = [
  { text: "بنزين", emoji: '⛽' },
  { text: "تفحيط", emoji: '💨🏎️' }, // Could also use a different "drifting" icon
  { text: "تغريدة", emoji: <FaTwitter /> },
  { text: "كفرات", emoji: <img src={wheel} className='w-6 ' /> }, // Tire iron icon
  { text: "إرهاب", emoji: '💣' },
  { text: "ثلاجة", emoji: <img src={fridge} className='w-6 ' /> },
];
  const nationalities = ['سعودي 🇸🇦', 'برتقالي 🍊', 'شمّري 🚩', 'مجهول ❓', 'ذبابي 🪰', 'اتحادي 🟨⬛'];
  const crimes = ["بنزين ⛽", "تفحيط 💨🏎️" , `تغريدة ${<FaTwitter />}`, "سرقة كفرات 🛞", "إرهاب 💣"];

  const NationalityCard = ({ nationality, isSelected, onClick }) => (
    <div
      className={`w-28 h-28 m-2 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 rounded-lg border ${
        isSelected ? 'bg-blue-500 text-white shadow-lg scale-105 border-blue-500' : 'bg-white hover:bg-gray-100 border-gray-300'
      }`}
      onClick={onClick}
    >
       <div className="text-center font-bold text-lg font-manal flex items-center"> {/* Add flex and items-center */}
      {nationality.emoji}  <span className="ml-2">{nationality.text}</span> {/* Add some spacing */}
    </div>
    </div>
  );

  const CrimeCard = ({ crime, isSelected, onClick }) => (
    <div
      className={`w-28 h-28 m-2 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 rounded-lg border ${
        isSelected
          ? "bg-red-500 text-white shadow-lg scale-105 border-red-500"
          : "bg-white hover:bg-gray-100 border-gray-300"
      }`}
      onClick={onClick}
    >
      <div className="text-center font-bold text-lg font-manal flex items-center">
        {crime.emoji} <span className="ml-2">{crime.text}</span>
      </div>
    </div>
  );

  const UserInfoDialog = ({ open, onClose, onSubmit }) => {
    const [name, setName] = useState('');
    const [nationality, setNationality] = useState('');
    const [selectedCrimes, setSelectedCrimes] = useState('');
  
    const handleSubmit = (event) => {
      event.preventDefault();
      onSubmit({ name, nationality, selectedCrimes });
    };

    const handleCrimeClick = (crime) => {
      if (selectedCrimes.includes(crime)) {
        setSelectedCrimes(selectedCrimes.filter((c) => c !== crime));
      } else if (selectedCrimes.length < 3) {
        setSelectedCrimes([...selectedCrimes, crime]);
      }
    };
  
    return (
      <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="p-6 text-center flex flex-col items-center font-manal"> {/* Apply text-right to the DialogContent */}
      <DialogTitle className="text-2xl font-bold ">لتقديم أفضل خدمة، اكتب الاسم واختر من الخيارات التالية</DialogTitle>
      <p className="mb-4">
        
      </p>

      {/* TextField becomes a regular input */}
      <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
        الاسم
      </label>
      <div className="w-screen px-4 mt-2">
        <input 
          type="text" 
          name="name" 
          id="name" 
          maxLength="150"
          autoComplete="name" 
          className="block w-full text-2xl rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <p className="text-lg font-semibold mt-4 mb-2">الجنسية</p> 
      <div className="grid grid-cols-3 gap-4"> {/* Apply grid layout */}
          {nationalitiesWithEmojis.map((nat) => (
            <NationalityCard
              key={nat.text}
              nationality={nat}
              isSelected={nationality === nat.text}
              onClick={() => setNationality(nat.text)}
            />
          ))} 
        </div>
        <p className="text-lg font-semibold mt-4 mb-2"> اختر الجرائم(متاح حتى 3 جرائم)</p> 

        <div className="grid grid-cols-3 gap-4 w-full max-w-sm">
          {crimesWithEmojis.map((c) => (
            <CrimeCard
              key={c.text}
              crime={c}
              isSelected={selectedCrimes.includes(c.text)}
              onClick={() => handleCrimeClick(c.text)}
            />
          ))}
        </div>

      <Slot name="footer" className="flex justify-end p-4">
        {/* Button becomes a button element */}
        <button disabled={!nationality || !name || selectedCrimes.length< 1} onClick={handleSubmit} className="bg-blue-500 text-white px-8 py-4 w-full text-center text-3xl justify-center shadow-md rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed">
          اخدمني يا وزارة الداخلية
        </button>
      </Slot>
    </DialogContent>
  </Dialog>
    );
  };

  export default function App() {
    const [showDialog, setShowDialog] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
  
    const handleSubmit = (info) => {
      setUserInfo(info);
      setShowLoading(true);
      setShowDialog(false);
    };

    useEffect(() => {
      let timer;
      if (showLoading) {
        timer = setTimeout(() => {
          setShowLoading(false); 
        }, 500); 
      }
      return () => clearTimeout(timer); 
    }, [showLoading]);



  return (
    <div dir="rtl">
      <UserInfoDialog open={showDialog} onClose={() => setShowDialog(false)} onSubmit={handleSubmit} />
      {showLoading && ( // Show loading message
        <div className="p-4 flex flex-col items-center justify-center ">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 font-manal"></div>
          <p className="mt-2">
            انتظر قليلا حتى يتم خدمتك من قبل وزارة الداخلية على أكمل وجه
          </p>
        </div>
      )}
      {!showLoading && userInfo && ( // Show Bayan after loading
        <Slot className="p-4">
          <Bayan {...userInfo} />
        </Slot>
      )}
    </div>
  );

}

